import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'

import { AuthContext, useAuthProvider } from '@/hooks/use-auth'
import { ErrorBoundary } from '@/components/error-boundary'
import { queryClient } from '@/router'

export const Route = createRootRoute({
    component: RootComponent,
})

function RootComponent() {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <AuthProvider />
                <Toaster position="top-center" richColors />
                {/* Hidden under E2E: the floating badge overlays the sidebar
                    footer and intercepts clicks on the logout button. */}
                {import.meta.env.DEV && !import.meta.env.VITE_E2E && (
                    <TanStackRouterDevtools />
                )}
            </QueryClientProvider>
        </ErrorBoundary>
    )
}

function AuthProvider() {
    const auth = useAuthProvider()
    return (
        <AuthContext.Provider value={auth}>
            <Outlet />
        </AuthContext.Provider>
    )
}
